export default "__VITE_ASSET__lMiaKoyZ__"